// @ts-check

// Web Crypto API encryption using RSAES-OAEP-SHA256 to match AWS KMS on server side.
const NONPROD_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1zMlFctm/LQq0U6XlNTp
7warfSSeIpoV/j5G63eIefYenunQT9iQ6mjpW8JpZm3w0mXDnu+x9gJAU8y1O7Xv
vUMsz4GMhfCXb9UmVYClMf+LmFJUN82pGj2fzm2MIVgimfxoyze8aQH57//O3ho2
OhFgFbGqX7nCM4fyTzcKeqNVsG2C9q1kmTTBdw4aJqUgnQa38wQDi1lrdk4AKNOP
NmM3V3hajHDVSG+uRs/6j7OZVERDQL0YDy4SPwrRSQ5gMUt4vGTiRY8hMXf3COXc
pF7bAswD7NQWUs8isHCumt/2+hH1Ybyf/L3qLWpPCy4zzJfwFEC+pbnME0Te5+p1
mwIDAQAB
-----END PUBLIC KEY-----`;

const PROD_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlzqULhcKpqsfuEoek34K
28XvWBwX3GUjcGzaGUkic0YE08AxnHQb7VQXCDV3PI/Vl6T0Fgz0MUyTw5L5mnCO
RVTciGiRH6JHSfIZJN3Ov3UleGZfReNUBzuyuGXFHcWcZVF71duf4CwOf58w+fn8
se9XNgr5SOiBfRhDwE2i1iYuxIoh44fwlvj5hRWfjJqHFZctqvBVxd2yhj093RyL
jB9yypYPwTJNuKjSJY4RllDUIV/yhZM2WiSdO4Prdw8Mu0AkV6vm9C7JdyHlmKCD
kY6lRwxGWaYLAv576BLeu73RuwAnxly/csl8c/CNr6Bh5cb1K6C/qmkd0kdIuq5j
IQIDAQAB
-----END PUBLIC KEY-----`;

const PROD_CLIENT_ID = 'acan-campaign-builder-public'

const PUBLIC_KEY = (process.env.REACT_APP_CLIENT_ID === PROD_CLIENT_ID)
  ? PROD_PUBLIC_KEY
  : NONPROD_PUBLIC_KEY;

// Convert PEM to ArrayBuffer.
function pemToArrayBuffer(pem) {
  const b64Lines = pem.replace(/-----[^-]+-----/g, '').replace(/\s/g, '');
  const b64 = b64Lines.replace(/\n/g, '');
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

export const encryptJson = async (data) => {
  try {
    // Import the public key for Web Crypto API.
    const keyBuffer = pemToArrayBuffer(PUBLIC_KEY);
    const publicKey = await crypto.subtle.importKey(
      'spki',
      keyBuffer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      false,
      ['encrypt'],
    );

    // Encrypt the data.
    const dataString = JSON.stringify(data);
    const encodedData = new TextEncoder().encode(dataString);

    const encryptedBuffer = await crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP',
      },
      publicKey,
      encodedData,
    );

    // Convert to base64.
    const encryptedArray = new Uint8Array(encryptedBuffer);
    const binaryString = Array.from(encryptedArray)
      .map((byte) => String.fromCharCode(byte))
      .join('');
    const base64 = btoa(binaryString);

    return base64;
  } catch (error) {
    throw new Error('Failed to encrypt data');
  }
};
